<template>
  <div class="user-info-container">
    <Row :gutter="20">
      <!-- 左侧个人信息卡片 -->
      <Col span="12">
        <Card class="info-card">
          <div class="info-content">
            <div class="avatar-section">
              <Avatar
                :size="130"
                :src="
                  userInfo.avatar
                    ? userInfo.avatar.includes('http')
                      ? userInfo.avatar
                      : IMAGE_HOST + userInfo.avatar
                    : userInfo.sex === 1
                    ? useravatar_1
                    : useravatar_2
                "
              />
            </div>
            <div class="info-section">
              <div class="greeting">
                {{ greeting }}，{{ userInfo.userName }}
              </div>
              <div class="department">所属科室：{{ userInfo.deskName }}</div>
              <div class="role">
                所属角色：{{
                  userInfo.roles.map((role) => role.roleName).join("、")
                }}
              </div>
              <div>合理工作,注意休息哦~</div>
            </div>
          </div>
        </Card>
      </Col>

      <!-- 右侧二维码卡片 -->
      <Col span="12">
        <Card class="qr-card">
          <div class="qr-content">
            <div class="avatar-section">
              <Avatar
                :size="200"
                shape="square"
                :src="qrCodeUrl || beiqrCodeUrl"
                @error="handleAvatarError"
              />
            </div>
            <div class="qr-tip">微信扫描当前二维码进入小程序进行报修</div>
            <div class="qr-download">
              <Button type="info" @click="downloadQR">下载</Button>
            </div>
          </div>
        </Card>
      </Col>
    </Row>

    <!-- 公告栏列表 -->
    <Row class="notice-list">
      <Col span="24">
        <Card>
          <template #title>
            <div class="notice-header">
              <Icon type="md-notifications" />
              <span>系统公告栏</span>
            </div>
          </template>
          <div class="notice-content">
            <div
              v-for="item in noticeList"
              :key="item.noticeId"
              class="notice-item"
            >
              <div class="notice-title">
                <span
                  class="notice-type"
                  :class="{ 'is-top': item.topping === 1 }"
                >
                  {{ item.noticeType === "1" ? "通知" : "公告" }}
                </span>
                {{ item.noticeTitle }}
              </div>
              <div class="notice-content-text">{{ item.noticeContent }}</div>
              <div class="notice-time">{{ item.createTime }}</div>
            </div>
            <div v-if="!noticeList.length" class="no-notice">暂无公告</div>
          </div>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
import { IMAGE_HOST } from "../../../config";
export default {
  name: "UserInfo",
  data() {
    return {
      useravatar_1: require("../../assets/img/useravatar_1.png"),
      useravatar_2: require("../../assets/img/useravatar_2.png"),
      beiqrCodeUrl: require("../../assets/img/weapp.jpg"),
      userInfo: {
        avatar: "",
        name: "",
        department: "",
        roles: [],
      },
      qrCodeUrl: "",
      IMAGE_HOST: IMAGE_HOST,
      noticeList: [],
    };
  },
  created() {
    this.getUserInfo();
    this.getQrCode();
    this.getNoticeList();
  },
  computed: {
    greeting() {
      const hour = new Date().getHours();
      if (hour < 12) return "早上好";
      if (hour < 18) return "下午好";
      return "晚上好";
    },
  },
  destroyed() {},
  methods: {
    errorHandler() {
      return true;
    },
    async getUserInfo() {
      let id = $utils.data.get("auth", "uid");
      let q = {};
      let res = await $utils.api.load(`/admin/system/user/${id}`, q, "get");
      if (res.code == 200) {
        this.userInfo = {
          ...res.data,
          roles: res.data.roles || [],
        };
      } else {
        this.$Message.error(res.message);
      }
    },
    async getQrCode() {
      try {
        const id = window.localStorage.getItem("customerId");
        const res = await $utils.api.load(
          `/admin/system/customer/getQrCode/${id}`,
          {},
          "get"
        );
        if (res.code === 200) {
          const qrCodePath = res.data.qrCodePath;
          // 确保图片路径正确拼接
          this.qrCodeUrl = qrCodePath.startsWith("http")
            ? qrCodePath
            : `${IMAGE_HOST}${qrCodePath}`;
        } else {
          this.$Message.error(res.message || "获取二维码失败");
        }
      } catch (error) {
        console.error("获取二维码失败:", error);
        this.$Message.error("获取二维码失败");
      }
    },
    async getNoticeList() {
      let q = {
        page: 1,
        limit: 10,
        topping: 1,
      };
      let res = await $utils.api.load("/admin/system/notice/list", q, "get");
      if (res.code == 200) {
        this.noticeList = res.rows || [];
      } else {
        this.$Message.error(res.message);
      }
    },
    handleAvatarError() {
      // 根据性别显示默认头像
      return this.userInfo.sex === 1 ? this.useravatar_1 : this.useravatar_2;
    },

    // 下载二维码
    downloadQR() {
      if (!this.qrCodeUrl) {
        this.$Message.error("二维码不存在");
        return;
      }
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.onerror = () => {
        this.$Message.error("图片加载失败");
      };
      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          const url = canvas.toDataURL("image/png");
          const link = document.createElement("a");
          link.download = "报修码.png";
          link.href = url;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.$Message.success("下载成功");
        } catch (error) {
          console.error("下载失败:", error);
          this.$Message.error("下载失败");
        }
      };

      img.src = this.qrCodeUrl;
    },
  },
};
</script>

<style lang="less" scoped>
.user-info-container {
  padding: 20px;

  .info-card,
  .qr-card {
    height: 300px;

    .ivu-card-body {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .info-content {
    display: flex;
    align-items: center;
    width: 100%;

    .avatar-section {
      margin-right: 20px;
    }

    .info-section {
      flex: 1;

      .greeting {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 15px;
      }

      .department,
      .role {
        font-size: 14px;
        color: #666;
        margin-bottom: 10px;
      }
    }
  }

  .qr-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;

    .qr-code {
      margin-bottom: 10px;

      img {
        width: 200px;
        height: 200px;
      }
    }

    .qr-tip {
      font-size: 14px;
      color: #666;
      margin-bottom: 10px;
      text-align: center;
    }

    .qr-download {
      .ivu-btn {
        min-width: 100px;
      }
    }
  }

  .notice-list {
    margin-top: 20px;

    .notice-header {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: bold;

      .ivu-icon {
        margin-right: 8px;
        font-size: 20px;
      }
    }

    .notice-content {
      .notice-item {
        padding: 16px;
        border-bottom: 1px solid #e8e8e8;
        transition: all 0.3s;

        &:hover {
          background: #f8f8f9;
        }

        &:last-child {
          border-bottom: none;
        }

        .notice-title {
          display: flex;
          align-items: center;
          margin-bottom: 12px;

          .notice-type {
            padding: 2px 8px;
            border-radius: 4px;
            font-size: 12px;
            margin-right: 8px;
            background: #e6f7ff;
            color: #1890ff;

            &.is-top {
              background: #fff1f0;
              color: #f5222d;
            }
          }
        }

        .notice-content-text {
          color: #666;
          font-size: 14px;
          line-height: 1.6;
          margin-bottom: 12px;
          white-space: pre-wrap;
          word-break: break-all;
        }

        .notice-time {
          font-size: 12px;
          color: #999;
        }
      }

      .no-notice {
        text-align: center;
        padding: 20px 0;
        color: #999;
      }
    }
  }
}
</style>
